import type { SVGProps } from 'react';
const datetimeClockgenericTemplateOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 6.61522 6.61522 2.25 12 2.25ZM12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 16.5563 7.44365 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM12 6C12.4142 6 12.75 6.33579 12.75 6.75V11.8464C12.75 12.1417 12.6338 12.4253 12.4266 12.6357L9.60392 15.502C9.31328 15.7972 8.83842 15.8008 8.54329 15.5102L8.48036 15.44C8.24934 15.1475 8.26687 14.722 8.53515 14.4495L11.25 11.6925V6.75C11.25 6.33579 11.5858 6 12 6Z"
      fill={props.color ?? '#144761'}
      fillRule="evenodd"
    />
  </svg>
);
export default datetimeClockgenericTemplateOutline;
